import * as React from "react"
import {Box, CircularProgress, Typography} from "@mui/material";


export default function NumItemsLoadingBlock() {
	return <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
		<CircularProgress size="0.9rem" />
		<Typography variant="caption">
			Calculated, please wait
		</Typography>
	</Box>
}